// Set to the same value as the web property used on the site
var gaProperty = $('body').data('gacode');
// Disable tracking if the opt-out cookie exists.
var disableStr = 'ga-disable-' + gaProperty;

// ##### Facebook Props
// var fpProperty = 'mde-service';
// var fpdisableStr = 'fp-disable-' + fpProperty;
//
// !function (f, b, e, v, n, t, s) {
//     if (f.fbq) return;
//     n = f.fbq = function () {
//         n.callMethod ?
//             n.callMethod.apply(n, arguments) : n.queue.push(arguments)
//     };
//     if (!f._fbq) f._fbq = n;
//     n.push = n;
//     n.loaded = !0;
//     n.version = '2.0';
//     n.queue = [];
//     t = b.createElement(e);
//     t.async = !0;
//     t.src = v;
//     s = b.getElementsByTagName(e)[0];
//     s.parentNode.insertBefore(t, s)
// }(window, document, 'script',
//     'https://connect.facebook.net/en_US/fbevents.js');
// fbq('init', '128832804540460');//Hier Ihre ID einsetzen



// function fpOptout() {
//     document.cookie = fpdisableStr + '=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/';
//     window[fpdisableStr] = true; // Disable Facebook
//     //console.log("Aus Facebook abgemeldet!");
// }


if (document.cookie.indexOf(disableStr + '=true') > -1) {
    gaOptout();
}

function gaOptout() {
    document.cookie = disableStr + '=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/';
    window[disableStr] = true;
    //console.log("Aus Google abgemeldet!");
}

// function fpEnable() {
//     document.cookie = fpdisableStr + '=false; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/';
//     window[fpdisableStr] = false; // Disable Facebook
//     //console.log("In Facebook angemeldet!");
// }

function enablecookies() {
    window.dataLayer = window.dataLayer || [];

    function gtag() {
        dataLayer.push(arguments);
    }

    gtag('js', new Date());
    gtag('config', gaProperty, {'anonymize_ip': true});
    document.cookie = disableStr + '=false; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/';
    window[disableStr] = false;
    //console.log("In Google angemeldet!");
}


function sendGTAG() {
    window.dataLayer = window.dataLayer || [];

    function gtag() {
        dataLayer.push(arguments);
    }

    gtag('js', new Date());
    gtag('config', gaProperty, {'anonymize_ip': true});
    window[disableStr] = false;
    //console.log("Google Page View gesendet!");
}


var ccsettings = $('body').data('cookieconsent');

//console.log(ccsettings);

window.addEventListener("load", function () {


    window.cookieconsent.initialise({
        "type": "" + ccsettings.type + "",
        "revokable": true,
        "theme": "" + ccsettings.theme + "",
        "position": "" + ccsettings.position + "",
        "palette": {
            "popup": {
                "background": "" + ccsettings.popupbgcolor + "",
                "text": "" + ccsettings.popupcolor + ""
            },
            "button": {
                "background": "" + ccsettings.buttonbgcolor + "",
                "text": "" + ccsettings.buttoncolor + "",
                "border": "" + ccsettings.buttonbordercolor + ""
            }
        },

        "revokeBtn" : ""+ccsettings.revokeBtn+"",

        "content": {
            "message": "" + ccsettings.message + "",
            "dismiss": "" + ccsettings.dismiss + "",
            "deny": "" + ccsettings.deny + "",
            "allow": "" + ccsettings.allow + "",
            "link": "" + ccsettings.link + "",
            "href": "" + ccsettings.href + ""
        },

        onPopupOpen: function () {
            var type = this.options.type;
            if (type == 'opt-out' && (typeof didConsent == 'undefined')) {
                sendGTAG();
                fbq('track', 'PageView');
            }

            if (type == 'info' && (typeof didConsent == 'undefined')) {
                sendGTAG();
                fbq('track', 'PageView');
            }

        },

        onPopupClose: function () {

        },

        onInitialise: function (status) {
            var type = this.options.type;
            var didConsent = this.hasConsented();

            if (type == 'opt-in' && didConsent) {
                if (status == 'allow') {
                    sendGTAG();
                    // fbq('track', 'PageView');
                }
                if (status == 'dismiss') {
                    gaOptout();
                    // fpOptout();
                }
                setTimeout(function () {
                    document.getElementsByClassName("cc-revoke")[0].style.display = "block";
                });
            }

            if (type == 'opt-in' && !didConsent) {
                gaOptout();
                // fpOptout();
                setTimeout(function () {
                    document.getElementsByClassName("cc-revoke")[0].style.display = "block";
                });
            }

            if (type == 'opt-out' && !didConsent) {
                gaOptout();
                // fpOptout();
                setTimeout(function () {
                    document.getElementsByClassName("cc-revoke")[0].style.display = "block";
                });

            }

            if (type == 'opt-out' && didConsent) {
                sendGTAG();
                // fbq('track', 'PageView');
                setTimeout(function () {
                    document.getElementsByClassName("cc-revoke")[0].style.display = "block";
                });
            }

        },

        onStatusChange: function (status, chosenBefore) {
            var type = this.options.type;
            var didConsent = this.hasConsented();

            if (type == 'opt-in' && didConsent) {

                if (status == 'allow') {
                    enablecookies();
                    // fpEnable();
                    // fbq('track', 'PageView');
                }

                if (status == 'dismiss') {
                    gaOptout();
                    // fpOptout();
                }
            }

            if (type == 'opt-in' && !didConsent) {
                gaOptout();
                // fpOptout();
            }

            if (type == 'opt-out' && !didConsent) {
                gaOptout();
                // fpOptout();
            }

            if (type == 'opt-out' && didConsent) {
                enablecookies();
                // fpEnable();
                // fbq('track', 'PageView');
            }
        },

        onRevokeChoice: function () {
            var type = this.options.type;
            if (type == 'opt-in') {
            } else if (type == 'opt-out') {
            }
        }
    })
});


// WEBPACK FOOTER //
// ./src/js/cookies.js